import { Dispatch } from 'react';
import { IStateRecharge } from 'src/entity/StateEntity';
import APIS from 'src/constants/ApiConfig';
import { IRechargeInfo, RECHARGE_A_YEAR, RECHARGE_SEVEN_DAY, RECHARGE_A_MONTH, RECHARGE_A_QUARTER, IRechargeOption } from 'src/entity/RechargeEntity';
import HttpService from 'src/services/HttpService';
import * as ActionTypes from 'src/constants/ActionTypes';

/**
 * 默认增值服务
 */
export const RechargeOptionList: IRechargeInfo[] = [
  {
    value: 0,
    name: '1个月增值服务',
    key: 'doc_recharge_one_month',
    type: RECHARGE_A_MONTH,
  },
  {
    value: 1,
    name: '1个季度增值服务',
    key: 'doc_recharge_one_quarter',
    type: RECHARGE_A_QUARTER,
  },
  {
    value: 2,
    name: '1年增值服务',
    key: 'doc_recharge_one_year',
    type: RECHARGE_A_YEAR,
  },
  {
    value: 4,
    name: '7天增值服务',
    key: 'doc_recharge_seven_day',
    type: RECHARGE_SEVEN_DAY,
  },
];

export const receiveRechargeOptions = (options: IRechargeOption[]): IStateRecharge => {
  const tempOptionList: IRechargeInfo[] = [];
  for (const optionObj of options) {
    const tempObj = RechargeOptionList.find(t => t.value === optionObj.package);
    if (!!tempObj) {
      tempOptionList.push(tempObj);
    }
  }
  return {
    type: ActionTypes.RECHARGE_SUCCESS,
    options: tempOptionList,
  };
};

export function fetchRechargeOptions(): any {
  return async (dispatch: Dispatch<IStateRecharge>) => {
    return HttpService.get(APIS.domainUrl(APIS.rechargeOption))
      .then((res: IRechargeOption[]) => dispatch(receiveRechargeOptions(res)))
      .catch(() => dispatch(receiveRechargeOptions([])));
  };
}

export function fetchRechargeOptionsIfNeeded(): any {
  return (dispatch: Dispatch<IStateRecharge>) => {
    return dispatch(fetchRechargeOptions());
  };
}

export const filterRechargeOption = (rechargeItem: IRechargeInfo[], freeCount: number): IRechargeInfo[] => {
  const items: IRechargeInfo[] = [];
  for (const item of rechargeItem) {
    if (item.type === RECHARGE_SEVEN_DAY) {
      if (freeCount > 0) {
        items.push(item);
      }
    } else {
      items.push(item);
    }
  }
  return items;
};



// WEBPACK FOOTER //
// ./src/redux/actions/rechargeCreator.ts